import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhomSection() {
  const forYou = ['Tu cachorro o perro adulto se altera cuando te vas o cierras puertas', 'Quieres un sistema corto, medible, sin "teorías eternas"', 'Te importa el bienestar, pero también necesitas volver a vivir'];
  const notForYou = ['Hay autolesión o intentos de escape peligrosos', 'Sospechas dolor/enfermedad sin descartar', 'Buscas "una técnica mágica" sin practicar'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-38">
          Para quién es (y para quién no)
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-39">
          <motion.div className="bg-[#C7E0E7]/5 rounded-2xl p-8" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-40">
            <h3 className="text-2xl font-bold text-[#C7E0E7] mb-6" data-id="element-41">
              Es para ti si:
            </h3>
            <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} data-id="element-42">
              {forYou.map((item, index) => <motion.li key={index} className="flex items-start" variants={itemVariants} data-id="element-43">
                  <CheckCircleIcon className="h-6 w-6 text-[#C7E0E7] mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-44" />
                  <span className="text-[#2C2C2C]" data-id="element-45">{item}</span>
                </motion.li>)}
            </motion.ul>
          </motion.div>

          <motion.div className="bg-red-50 rounded-2xl p-8" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-46">
            <h3 className="text-2xl font-bold text-red-600 mb-6" data-id="element-47">
              No es para ti si:
            </h3>
            <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} data-id="element-48">
              {notForYou.map((item, index) => <motion.li key={index} className="flex items-start" variants={itemVariants} data-id="element-49">
                  <XCircleIcon className="h-6 w-6 text-red-500 mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-50" />
                  <span className="text-[#2C2C2C]" data-id="element-51">{item}</span>
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>
      </div>
    </section>;
}